// src/components/InstallBanner.js
import React, { useState } from "react";

export default function InstallBanner() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("tl_install_banner_dismissed") === "true"
  );
  const [showTuto, setShowTuto] = useState(false);

  function dismiss() {
    localStorage.setItem("tl_install_banner_dismissed", "true");
    setDismissed(true);
  }

  if (dismissed) return null;

  return (
    <>
      {!showTuto ? (
        <div style={s.banner}>
          <span style={s.icon}>📱</span>
          <div style={s.text}>
            <strong>Installez TomboLive</strong> sur votre téléphone pour un accès rapide lors de vos événements !
          </div>
          <div style={s.actions}>
            <button onClick={() => setShowTuto(true)} style={s.btnInstall}>
              Voir comment
            </button>
            <button onClick={dismiss} style={s.btnDismiss}>✕</button>
          </div>
        </div>
      ) : (
        <div style={s.tutoOverlay}>
          <div style={s.tutoCard}>
            <button onClick={() => setShowTuto(false)} style={s.btnClose}>✕</button>
            <h2 style={s.tutoTitle}>📱 Installer TomboLive</h2>
            <p style={s.tutoSubtitle}>Accédez à l'app en un tap, comme une vraie application !</p>

            {/* Android */}
            <div style={s.platform}>
              <div style={s.platformTitle}>🤖 Android (Chrome)</div>
              <div style={s.steps}>
                {[
                  "Ouvrez app.tombo.live dans Chrome",
                  'Appuyez sur les ⋮ (3 points) en haut à droite',
                  'Appuyez sur "Ajouter à l\'écran d\'accueil"',
                  'Confirmez en appuyant sur "Ajouter"',
                ].map((step, i) => (
                  <div key={i} style={s.step}>
                    <div style={s.stepNum}>{i + 1}</div>
                    <div style={s.stepText}>{step}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* iOS */}
            <div style={s.platform}>
              <div style={s.platformTitle}>🍎 iPhone / iPad (Safari)</div>
              <div style={s.steps}>
                {[
                  "Ouvrez app.tombo.live dans Safari",
                  "Appuyez sur l'icône partage (carré avec flèche ↑)",
                  'Faites défiler et appuyez sur "Sur l\'écran d\'accueil"',
                  'Appuyez sur "Ajouter"',
                ].map((step, i) => (
                  <div key={i} style={s.step}>
                    <div style={s.stepNum}>{i + 1}</div>
                    <div style={s.stepText}>{step}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={s.infoBox}>
              💡 Une fois installée, l'app apparaît sur votre écran d'accueil comme une vraie application — sans passer par le navigateur !
            </div>

            <button onClick={dismiss} style={s.btnOk}>
              ✅ J'ai installé l'application
            </button>
            <button onClick={() => setShowTuto(false)} style={s.btnLater}>
              Plus tard
            </button>
          </div>
        </div>
      )}
    </>
  );
}

const s = {
  // Bannière
  banner: { display:"flex", alignItems:"center", gap:"10px", background:"linear-gradient(135deg,#eef0ff,#f5f0ff)", borderBottom:"1px solid #c7d2ff", padding:"0.65rem 1rem", flexWrap:"wrap" },
  icon: { fontSize:"1.25rem", flexShrink:0 },
  text: { flex:1, fontSize:"0.85rem", color:"#333", lineHeight:1.5 },
  actions: { display:"flex", gap:"8px", alignItems:"center", flexShrink:0 },
  btnInstall: { padding:"5px 14px", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"8px", cursor:"pointer", fontWeight:"700", fontSize:"0.82rem" },
  btnDismiss: { background:"none", border:"none", color:"#aaa", cursor:"pointer", fontSize:"1rem", padding:"4px 6px" },

  // Tuto overlay
  tutoOverlay: { position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:2000 },
  tutoCard: { background:"#fff", borderRadius:"20px 20px 0 0", width:"100%", maxWidth:"520px", padding:"1.75rem 1.5rem 2rem", maxHeight:"90vh", overflowY:"auto", position:"relative" },
  btnClose: { position:"absolute", top:"1rem", right:"1rem", background:"#f5f5f5", border:"none", borderRadius:"50%", width:"32px", height:"32px", cursor:"pointer", fontSize:"0.9rem", display:"flex", alignItems:"center", justifyContent:"center" },
  tutoTitle: { fontSize:"1.3rem", fontWeight:"800", color:"#1a1a2e", marginBottom:"0.4rem", textAlign:"center" },
  tutoSubtitle: { fontSize:"0.88rem", color:"#888", textAlign:"center", marginBottom:"1.5rem" },

  // Plateformes
  platform: { background:"#f7f8fc", borderRadius:"12px", padding:"1rem", marginBottom:"1rem", border:"1px solid #eee" },
  platformTitle: { fontWeight:"700", color:"#1a1a2e", fontSize:"0.95rem", marginBottom:"0.75rem" },
  steps: { display:"flex", flexDirection:"column", gap:"8px" },
  step: { display:"flex", alignItems:"flex-start", gap:"10px" },
  stepNum: { width:"24px", height:"24px", borderRadius:"50%", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:"700", fontSize:"0.78rem", flexShrink:0 },
  stepText: { fontSize:"0.85rem", color:"#444", lineHeight:1.5, paddingTop:"2px" },

  // Info & boutons
  infoBox: { background:"#eef0ff", borderRadius:"10px", padding:"0.85rem", fontSize:"0.82rem", color:"#4c5ee8", lineHeight:1.6, marginBottom:"1.25rem", border:"1px solid #c7d2ff" },
  btnOk: { width:"100%", padding:"0.85rem", background:"linear-gradient(135deg,#2e7d32,#43a047)", color:"#fff", border:"none", borderRadius:"12px", fontWeight:"700", cursor:"pointer", fontSize:"0.95rem", marginBottom:"8px" },
  btnLater: { width:"100%", padding:"0.75rem", background:"none", border:"none", color:"#aaa", cursor:"pointer", fontSize:"0.85rem" },
};
